import Vue from 'vue';
import VueRouter from 'vue-router';
import { o } from 'ramda';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index'),
    redirect: '/home',
    meta: {
      requiresAuth: true,
      noCache: false,
      roles: [1, 2, 3, 4],
    },
    children: [
      {
        path: 'home',
        component: () => import('@/views/home'),
        meta: {
          title: 'tIndex',
          requiresAuth: true,
          noCache: false,
          roles: [1, 2, 3, 4],
        },
      },
      {
        path: 'notification',
        component: () => import('@/views/notification'),
        meta: {
          title: 'tNotification',
          requiresAuth: true,
          noCache: false,
          roles: [1, 2, 3, 4],
        },
      },
      {
        path: 'carouselManagement',
        component: () => import('@/components/animate'),
        redirect: '/carouselManagement',
        meta: {
          title: 'tCarouselManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1],
        },
        children: [
          {
            path: '',
            component: () => import('@/views/carouselManagement'),
            name: 'carouselManagement',
            meta: {
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'detail',
            component: () => import('@/views/carouselManagement/detail'),
            name: 'carouselDetail',
            meta: {
              title: 'tCarouselDetail',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'edit',
            component: () => import('@/views/carouselManagement/edit'),
            name: 'carouselEdit',
            meta: {
              title: 'tCarouselEdit',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
        ],
      },
      {
        path: 'memberManagement',
        component: () => import('@/components/animate'),
        redirect: '/memberManagement',
        meta: {
          title: 'tMemberManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1],
        },
        children: [
          {
            path: '',
            component: () => import('@/views/memberManagement'),
            name: 'memberList',
            meta: {
              title: 'tMemberList',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path:'active',
            component: () => import('@/views/memberManagement/active'),
            name:'active',
            meta: {
              title:'tActiveMemberList',
              requiresAuth: true,
              noCache: false,
              roles:[1]
            },
          },
          {
            path:'withdraw',
            component: () => import('@/views/memberManagement/withdraw'),
            name:'withdraw',
            meta: {
              title:'tWithdrawMemberList',
              requiresAuth: true,
              noCache: false,
              roles:[1]
            },
          },
          {
            path:'disable',
            component: () => import('@/views/memberManagement/disable'),
            name: 'disable',
            meta: {
              title: 'tMemberDisable',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'del',
            component: () => import('@/views/memberManagement/del'),
            name: 'del',
            meta: {
              title: 'tMemberDel',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'dormant',
            component: () => import('@/views/memberManagement/dormant'),
            name: 'dormant',
            meta: {
              title: 'tDormant',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'detail',
            component: () => import('@/views/memberManagement/detail'),
            name: 'memberDetail',
            meta: {
              title: 'tMemberDetail',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'edit',
            component: () => import('@/views/memberManagement/edit'),
            name: 'memberEdit',
            meta: {
              title: 'tMemberEdit',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'send',
            component: () => import('@/views/memberManagement/send'),
            name: 'send',
            meta: {
              title: 'tSend',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: ':id/attendance',
            component: () => import('@/views/memberManagement/attendance'),
            name: 'memberAttendance',
            meta: {
              title: 'tMemberAttendance',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: ':id/comment',
            component: () => import('@/views/memberManagement/comment'),
            name: 'memberComment',
            meta: {
              title: 'tMemberComment',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: ':id/discuss',
            component: () => import('@/views/memberManagement/discuss'),
            name: 'memberDiscuss',
            meta: {
              title: 'tMemberDiscuss',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
        ],
      },
      {
        path: 'readManagement',
        name: 'readManagement',
        redirect: '/readManagement/readList',
        component: () => import('@/components/animate'),
        meta: {
          title: 'tReadManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1, 2],
        },
        children: [
          {
            path: 'readList',
            redirect: '/readManagement/readList',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tReadList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2],
            },
            children: [
              {
                path: '',
                name: 'readList',
                component: () => import('@/views/readManagement/readList'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
              {
                path: 'edit',
                name: 'editRead',
                component: () => import('@/views/readManagement/readList/edit'),
                meta: {
                  title: 'tEditRead',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
              {
                path: 'detail',
                name: 'readDetail',
                component: () =>
                  import('@/views/readManagement/readList/detail'),
                meta: {
                  title: 'tReadDetail',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
              {
                path: ':readId/readNoticeList',
                redirect: '/readManagement/readList/:readId/readNoticeList',
                component: () => import('@/components/animate'),
                meta: {
                  title: 'tReadNoticeList',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
                children: [
                  {
                    path: '',
                    name: 'readNoticeList',
                    component: () =>
                      import('@/views/readManagement/readList/readNoticeList'),
                    meta: {
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                  {
                    path: 'edit',
                    name: 'editReadNotice',
                    component: () =>
                      import(
                        '@/views/readManagement/readList/readNoticeList/edit'
                      ),
                    meta: {
                      title: 'tEditReadNotice',
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                ],
              },
              {
                path: ':readId/readTaskList',
                component: () => import('@/components/animate'),
                meta: {
                  title: 'tReadTaskList',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
                children: [
                  {
                    path: '',
                    name: 'readTaskList',
                    component: () =>
                      import('@/views/readManagement/readList/readTaskList'),
                    meta: {
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                  {
                    path: 'edit',
                    name: 'editReadTask',
                    component: () =>
                      import(
                        '@/views/readManagement/readList/readTaskList/edit'
                      ),
                    meta: {
                      title: 'tEditReadTask',
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                  {
                    path: ':taskId/attendanceList',
                    component: () => import('@/components/animate'),
                    meta: {
                      title: 'tAttendanceList',
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                    children: [
                      {
                        path: '',
                        name: 'attendanceList',
                        component: () =>
                          import(
                            '@/views/readManagement/readList/readTaskList/attendanceList'
                          ),
                        meta: {
                          requiresAuth: true,
                          noCache: false,
                          roles: [1, 2],
                        },
                      },
                      {
                        path: 'comment',
                        name: 'comment',
                        component: () =>
                          import(
                            '@/views/readManagement/readList/readTaskList/attendanceList/comment'
                          ),
                        meta: {
                          title: 'tComment',
                          requiresAuth: true,
                          noCache: false,
                          roles: [1, 2],
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: ':readId/readTopicList',
                component: () =>
                  import('@/views/readManagement/readList/readTopicList'),
                meta: {
                  title: 'tReadTopicList',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
              {
                path: ':readId/readCommentList',
                redirect: '/readManagement/readList/:readId/readCommentList',
                component: () => import('@/components/animate'),
                meta: {
                  title: 'tReadCommentList',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
                children: [
                  {
                    path: '',
                    name: 'readCommentList',
                    component: () =>
                      import('@/views/readManagement/readList/readCommentList'),
                    meta: {
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                  {
                    path: 'edit',
                    name: 'editReadComment',
                    component: () =>
                      import(
                        '@/views/readManagement/readList/readCommentList/edit'
                      ),
                    meta: {
                      title: 'tEditReadComment',
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'read_userList',
            name: 'read_userList',
            component: () => import('@/views/readManagement/read_userList'),
            meta: {
              title: 'tReadUserList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2],
            },
          },
        ],
      },
      {
        path: 'serialManagement',
        name: 'serialManagement',
        redirect: '/serialManagement/serialList',
        component: () => import('@/components/animate'),
        meta: {
          title: 'tSerialManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1, 4],
        },
        children: [
          {
            path: 'serialList',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tSerialList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 4],
            },
            children: [
              {
                path: '',
                name: 'serialList',
                component: () => import('@/views/serialManagement'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 4],
                },
              },
              {
                path: 'chapterList',
                name: 'chapterList',
                redirect: '/serialManagement/serialList/chapterList',
                component: () => import('@/components/animate'),
                meta: {
                  title: 'tChapterList',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 4],
                },
                children: [
                  {
                    path: '',
                    component: () =>
                      import('@/views/serialManagement/chapterList'),
                    meta: {
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 4],
                    },
                  },
                  {
                    path: 'edit',
                    name: 'editChapter',
                    component: () =>
                      import('@/views/serialManagement/chapterList/edit'),
                    meta: {
                      title: 'tEditChapter',
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 4],
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'edit',
            name: 'editSerial',
            component: () => import('@/views/serialManagement/edit'),
            meta: {
              title: 'tEditSerial',
              requiresAuth: true,
              noCache: false,
              roles: [1, 4],
            },
          },
          {
            path: 'detail',
            name: 'serialDetail',
            component: () => import('@/views/serialManagement/detail'),
            meta: {
              title: 'tSerialDetail',
              requiresAuth: true,
              noCache: false,
              roles: [1, 4],
            },
          },
        ],
      },
      {
        path: 'activityManagement',
        name: 'activityManagement',
        redirect: '/activityManagement/activityList',
        component: () => import('@/components/animate'),
        meta: {
          title: 'tActivityManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1, 3],
        },
        children: [
          {
            path: 'activityList',
            redirect: '/activityManagement/activityList',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tActivityList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 3],
            },
            children: [
              {
                path: '',
                name: 'activityList',
                component: () =>
                  import('@/views/activityManagement/activityList'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 3],
                },
              },
              {
                path: 'edit',
                name: 'editActivity',
                component: () =>
                  import('@/views/activityManagement/activityList/edit'),
                meta: {
                  title: 'tEditActivity',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 3],
                },
              },
              {
                path: 'detail',
                name: 'activityDetail',
                component: () =>
                  import('@/views/activityManagement/activityList/detail'),
                meta: {
                  title: 'tActivityDetail',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 3],
                },
              },
            ],
          },
          {
            path: 'activity_userList',
            name: 'activity_userList',
            component: () =>
              import('@/views/activityManagement/activity_userList'),
            meta: {
              title: 'tActivityUserList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 3],
            },
          },
        ],
      },
      {
        path: 'orderManagement',
        component: () => import('@/components/animate'),
        redirect: '/orderManagement/orderList',
        meta: {
          title: 'tOrderManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1, 2],
        },
        children: [
          {
            path: 'orderList',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tOrderList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2],
            },
            children: [
              {
                path: '',
                name: 'orderList',
                component: () => import('@/views/orderManagement'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
              {
                path: 'detail',
                name: 'orderDetail',
                component: () => import('@/views/orderManagement/detail'),
                meta: {
                  title: 'tOrderDetail',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
            ],
          },
        ],
      },
      {
        path: 'couponManagement',
        name: 'couponManagement',
        redirect: '/couponManagement/couponList',
        component: () => import('@/components/animate'),
        meta: {
          title: 'tCouponManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1, 2],
        },
        children: [
          {
            path: 'couponList',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tCouponList',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2],
            },
            children: [
              {
                path: '',
                name: 'couponList',
                component: () => import('@/views/couponManagement'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
              {
                path: 'edit',
                component: () => import('@/components/animate'),
                meta: {
                  title: 'tEditCoupon',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
                children: [
                  {
                    path: '',
                    name: 'editCoupon',
                    component: () => import('@/views/couponManagement/edit'),
                    meta: {
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                  {
                    path: 'setmember',
                    name: 'setMember',
                    component: () => import('@/views/couponManagement/edit/setmember'),
                    meta: {
                      title: 'tSetMember',
                      requiresAuth: true,
                      noCache: false,
                      roles: [1, 2],
                    },
                  },
                ]
              },
              {
                path: 'couponUseList',
                name: 'couponUseList',
                component: () =>
                  import('@/views/couponManagement/couponUseList'),
                meta: {
                  title: 'tCouponUseList',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2],
                },
              },
            ],
          },
        ],
      },
      {
        path: 'serviceManagement',
        component: () => import('@/components/animate'),
        redirect: '/serviceManagement/serviceCommentList',
        meta: {
          title: 'tServiceManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1],
        },
        children: [
          {
            path: 'serviceCommentList',
            name: 'serviceCommentList',
            redirect: '/serviceManagement/serviceCommentList',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tServiceCommentList',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
            children: [
              {
                path: '',
                component: () =>
                  import('@/views/serviceManagement/serviceCommentList'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1],
                },
              },
              {
                path: 'edit',
                name: 'editComment',
                component: () =>
                  import('@/views/serviceManagement/serviceCommentList/edit'),
                meta: {
                  title: 'tEditComment',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1],
                },
              },
            ],
          },
          {
            path: 'serviceIntroduce',
            name: 'serviceIntroduce',
            component: () =>
              import('@/views/serviceManagement/serviceIntroduce'),
            meta: {
              title: 'tServiceIntroduce',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
        ],
      },
      {
        path: 'serviceCenter',
        redirect: '/serviceCenter/notice',
        component: () => import('@/components/animate'),
        meta: {
          title: 'tServiceCenter',
          requiresAuth: true,
          noCache: false,
          roles: [1, 2, 3],
        },
        children: [
          {
            path: 'notice',
            component: () => import('@/components/animate'),
            redirect: '/serviceCenter/notice',
            meta: {
              title: 'tNotice',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2, 3],
            },
            children: [
              {
                path: '',
                name: 'notice',
                component: () => import('@/views/serviceCenter/notice'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
              {
                path: 'edit',
                name: 'editNotice',
                component: () => import('@/views/serviceCenter/notice/edit'),
                meta: {
                  title: 'tEditNotice',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
            ],
          },
          {
            path: 'FAQ',
            component: () => import('@/components/animate'),
            redirect: '/serviceCenter/FAQ',
            meta: {
              title: 'tFAQ',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2, 3],
            },
            children: [
              {
                path: '',
                name: 'FAQ',
                component: () => import('@/views/serviceCenter/FAQ'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
              {
                path: 'edit',
                name: 'editFAQ',
                component: () => import('@/views/serviceCenter/FAQ/edit'),
                meta: {
                  title: 'tEditFAQ',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
            ],
          },
          {
            path: 'QA',
            component: () => import('@/components/animate'),
            meta: {
              title: 'tQA',
              requiresAuth: true,
              noCache: false,
              roles: [1, 2, 3],
            },
            children: [
              {
                path: '',
                name: 'QA',
                component: () => import('@/views/serviceCenter/QA'),
                meta: {
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
              {
                path: 'edit',
                name: 'editQA',
                component: () => import('@/views/serviceCenter/QA/edit'),
                meta: {
                  title: 'tEditQA',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
              {
                path: 'detail',
                name: 'QADetail',
                component: () => import('@/views/serviceCenter/QA/detail'),
                meta: {
                  title: 'tQADetail',
                  requiresAuth: true,
                  noCache: false,
                  roles: [1, 2, 3],
                },
              },
            ],
          },
        ],
      },
      {
        path: 'setting',
        component: () => import('@/components/animate'),
        redirect: '/setting',
        meta: {
          title: 'tSetting',
          requiresAuth: true,
          noCache: false,
          roles: [1],
        },
        children: [
          {
            path: '',
            name: 'setting',
            component: () => import('@/views/setting'),
            meta: {
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'edit',
            name: 'settingEdit',
            component: () => import('@/views/setting/edit'),
            meta: {
              title: 'tSettingEdit',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
        ],
      },
      {
        path: 'accountManagement',
        component: () => import('@/components/animate'),
        redirect: '/accountManagement',
        meta: {
          title: 'tAccountManagement',
          requiresAuth: true,
          noCache: false,
          roles: [1],
        },
        children: [
          {
            path: '',
            name: 'accountManagement',
            component: () => import('@/views/accountManagement'),
            meta: {
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'ip',
            name: 'ip',
            component: () => import('@/views/accountManagement/ip'),
            meta: {
              title: 'tIP',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
          {
            path: 'log',
            name: 'log',
            component: () => import('@/views/accountManagement/log'),
            meta: {
              title: 'tLog',
              requiresAuth: true,
              noCache: false,
              roles: [1],
            },
          },
        ],
      },
      // {
      //   path: 'accountManagement',
      //   name: 'accountManagement',
      //   component: () => import('@/views/accountManagement'),
      //   meta: {
      //     title:'tAccountManagement',
      //     requiresAuth: true,
      //     noCache: false,
      //     roles:[1]
      //   }
      // },
    ],
  },
];

let defaultRouter = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
    meta: {
      title: 'tLogin',
    },
  },
];

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: defaultRouter,
});
